import "./styles.scss";
import { Loading } from "../../utils/loading";
import Card from "./card";
import SchedulingDetailDialog from "./dialogs/SchedulingDetailDialog";
import useCalendar from "../../hooks/useCalendar";
import { useState, useEffect } from "react";
import { Select, Button } from "@rio-cloud/rio-uikit";

const Calendar = () => {
  const {
    currentDate,
    showCalendar,
    setShowCalendar,
    showDialog,
    setShowDialog,
    schedulingChoosed,
    setSchedulingChoosed,
    loading,
    monthSchedule,
    changeMonth,
    renderDays,
    daysOfWeek,
    monthNames,
  } = useCalendar();

  return (
    <div>
      <span
        className="indicated-icon"
        onClick={() => setShowCalendar(!showCalendar)}
      >
        <span className="rioglyph rioglyph-calendar !text-[#ffffff] !text-[30px]"></span>
      </span>

      {showCalendar && <>
        <div className="bg-calendar-sidebar" onClick={() => setShowCalendar(!showCalendar)} />
        <div className="calendar-sidebar">
          <div className="flex justify-between padding-right-20 calendar-sidebar__header">
            <h3 className="flex items-center gap-6 chat-sidebar__title text-color-map-marker-asset">
              <span className="rioglyph rioglyph-calendar text-color-map-marker-asset"></span>
              Calendário
            </h3>
            <div
              className="padding-top-20 close-sidebar cursor-pointer"
              onClick={() => setShowDialog(!showDialog)}
            >
              <span className="rioglyph rioglyph-remove"></span>
            </div>
          </div>

          <div className="calendar-container">
            <div className="calendar-header">
              <span  className="text-color-status-available text-normal text-size-16 hover:opacity-80">
                {monthNames[currentDate.getMonth()]} {currentDate.getFullYear()}
              </span>
              
              {!loading && <div className="calendar-header__nav">
                <button
                  className="rioglyph rioglyph-chevron-left text-size-14"
                  onClick={() => changeMonth(-1)}
                />
                <button
                  className="rioglyph rioglyph-chevron-right text-size-14"
                  onClick={() => changeMonth(1)}
                />
              </div>}
            </div>
            <div className="calendar-days-of-week">
              {daysOfWeek.map((day, index) => (
                <div key={index} className="calendar-day-name">
                  {day}
                </div>
              ))}
            </div>
            <div className="calendar-days">{renderDays()}</div>
          </div>

          <div className="schedule-container">
            <h3 className="flex items-center gap-4 chat-sidebar__title text-color-darker">
              <div className="border-b w-full pb-1">
                <span className="rioglyph rioglyph-checkboxes text-color-darker"></span>
                Agendamento
              </div>
            </h3>

            <div className="schedule-cards">
              {loading && <Loading label="Carregando agendamentos..." />}
              {!loading && monthSchedule
                .filter(
                  (scheduling) =>
                    scheduling.date.getDate() === currentDate.getDate()
                )
                .map((scheduling, index) => (
                  <Card
                    key={index}
                    setShowDialog={setShowDialog}
                    scheduling={scheduling}
                    chooseScheduling={() => setSchedulingChoosed(scheduling)}
                  />
                ))}
            </div>
          </div>
        </div>

        <SchedulingDetailDialog
          show={showDialog}
          onClose={() => setShowDialog(false)}
          scheduling={schedulingChoosed}
        />
      </>}
    </div>
  );
};

export default Calendar;
